import { c as _c } from "react/compiler-runtime";
import { formatLongString } from '@morpho-org/morpho-ts';
import { HoverableCell } from '@morpho-org/ui-v6/client';
import { memo } from 'react';
import type { RewardsTableRowData } from '@/hooks/reward/useRewardsTable';
import { TokenNetworkAvatar } from '@/components/common/TokenNetworkAvatar';
import { AssetRewardHoverCard } from './AssetRewardHoverCard';
export interface HoverableAssetRewardProps {
  reward: RewardsTableRowData;
  maxWidth?: string;
}
const HoverableAssetReward = t0 => {
  const $ = _c(19);
  const {
    reward,
    maxWidth
  } = t0;
  const asset = reward.rewardToken.token;
  let t1;
  if ($[0] !== asset || $[1] !== reward.type) {
    t1 = <AssetRewardHoverCard asset={asset} type={reward.type} />;
    $[0] = asset;
    $[1] = reward.type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== maxWidth) {
    t2 = {
      maxWidth
    };
    $[3] = maxWidth;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== asset) {
    t3 = <TokenNetworkAvatar asset={asset} />;
    $[5] = asset;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      lineHeight: "normal"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = asset.symbol ?? "";
  let t6;
  if ($[8] !== t5) {
    t6 = formatLongString(t5, 8);
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <span className="text-2xs line-clamp-1" style={t4}>{t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t7) {
    t8 = <div className="gap-2xs flex items-center" style={t2}>{t3}{t7}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t8) {
    t9 = <HoverableCell hoverCardContent={t1} padding="4px 6px">{t8}</HoverableCell>;
    $[16] = t1;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default memo(HoverableAssetReward);